export const ADMIN_GET_SUB_CATEGORY = 'ADMIN_GET_SUB_CATEGORY'
export const ADMIN_GET_SUB_CATEGORY_OF_CATEGORY = 'ADMIN_GET_SUB_CATEGORY_OF_CATEGORY'
export const ADMIN_ADD_SUB_CATEGORY = 'ADMIN_ADD_SUB_CATEGORY'
export const ADMIN_UPDATE_SUB_CATEGORY = 'ADMIN_UPDATE_SUB_CATEGORY'
export const ADMIN_DELETE_SUB_CATEGORY = 'ADMIN_DELETE_SUB_CATEGORY'
